import React, { useState } from "react";
import { Icon, Label, Menu } from "semantic-ui-react";
import "../../styles/ui.scss";

const BCToolTip = ({ ...props }) => {
  const [showTooltip, setTooltip] = useState(false); 

  return (
    <Menu className="tooltip-menu" compact>
      <Menu.Item onMouseEnter={() => setTooltip(true)} onMouseLeave={() => setTooltip(false)}>
        {props.children ? props.children : <Icon className="help-icon" name="question circle" />}
        {showTooltip && <Label className="tooltip-label" floating>{props.tooltip}</Label>}
      </Menu.Item>
    </Menu>
  );
};

export default BCToolTip;
